<template>
  <pipeline-chart
    :title="'Potential Volume'"
    :userRoute="userRoute"
    :type="'volume'"
    :size="'4'">
  </pipeline-chart>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import PipelineChart from '@/views/Components/Charts/PipelineChart';

export default {
  components: {
    PipelineChart
  },
  computed: {
    ...mapGetters({
      user: 'profile/user',
      userRoute: 'profile/userRoute',
    }),
  }
};
</script>